const arrowLeft = document.querySelector('.product__thumbs-wrapper .icon-arrow-left')
const arrowRight = document.querySelector('.product__thumbs-wrapper .icon-arrow-right')

const getThumbElementVariable = () => {
  const thumbsSlider = document.querySelector('.product__thumbs__holder')
  const thumbElement = document.querySelector('.product__thumb')


  if (!thumbsSlider || !thumbElement){
    return
  }

  const thumbElementWidth = thumbElement.offsetWidth + 10

  const scrollLeft = () => {
    thumbsSlider.scrollBy({
      top: 0,
      left: -Math.abs(thumbElementWidth),
      behavior: "smooth",
    });
  }

  const scrollRight = () => {
    thumbsSlider.scrollBy({
      top: 0,
      left: thumbElementWidth,
      behavior: "smooth",
    });
  }

  arrowLeft.addEventListener('click', scrollLeft)
  arrowRight.addEventListener('click', scrollRight)

  clearInterval(timerId);
}

(() => {
  timerId = setInterval(getThumbElementVariable, 200)
})();

